import { useLocation } from 'react-router';
import { useGetLoggedInUserQuery } from '../redux/features/auth/authApi';

export const useAuth = (skip = false) => {
  const token = localStorage.getItem('magjistraturaAppToken');
  const { pathname } = useLocation();

  const { data, isFetching, isError, refetch } = useGetLoggedInUserQuery(
    undefined,
    {
      skip: !token || skip || pathname.includes('login'),
    },
  );

  const fallbacks = ['/logout-success', '/auth/callback', '/forgot-password'];

  return {
    data,
    isFetching,
    isError:
      (isError || (!data && !isFetching) || !token) &&
      !fallbacks.includes(pathname),
    refetch,
  };
};
